// @todo: Migrate to 'Slider' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Slide, toast} from 'react-toastify';

export const nwToast = (msg: string) => toast(msg, {transition: Slide});
